import React, { useState } from 'react';
import constants from '../constants';
import { translate } from '../Services/translation';

const LanguageSelector = () => {
  const countries = constants.countries;
  const selectedCountry = countries.find((country) => country.selected);
  const [showList, onShowList] = useState(false);

  return (
    <div className="lang-selector">
      <div
        onClick={() => onShowList(!showList)}
        className="lang-selector__current"
      >
        <p>{selectedCountry.text}</p>
        <i className="lang-selector__icon-caret"></i>
      </div>
      {showList && (
        <div className="lang-selector__list">
          {countries.map((country) => {
            
            const translationKey = `language.${country.text.toLowerCase()}`;
            const translation = translate(translationKey);
            return (
            <div key={country.text} className="lang-selector__list__row">
              {country.selected ? (
                <i className="lang-selector__icon-checked"></i>
              ) : (
                <i></i>
              )}
              <a href={country.value}>{ translation !== translationKey ? translation : country.extendedText}</a>
            </div>
          )})}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
